import { render, staticRenderFns } from "./DocumentsForms.vue?vue&type=template&id=b694c93c&scoped=true&lang=pug&"
import script from "./DocumentsForms.vue?vue&type=script&lang=ts&"
export * from "./DocumentsForms.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsForms.vue?vue&type=style&index=0&id=b694c93c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b694c93c",
  null
  
)

export default component.exports